export const products = [
  {
    id: 'small',
    size: '250g',
    price: 5,
    image: '/assets/images/variations/alshifaa-250g.png',
    alt: 'Alshifaa pure honey 250 gram bottle',
  },
  {
    id: 'medium',
    size: '500g',
    price: 10,
    image: '/assets/images/variations/alshifaa-500g.png',
    alt: 'Alshifaa pure honey 500 gram bottle',
  },
  {
    id: 'large',
    size: '1kg',
    price: 20,
    image: '/assets/images/variations/alshifaa-1kg.png',
    alt: 'Alshifaa pure honey 1 kilogram bottle',
  },
]

export const business = {
  whatsapp: '252619609087',
  email: 'hello@alshifaahoney.com',
  currency: 'USD',
  locale: 'en-US',
}
